import { ApiLoadingSpinner, Button } from "@funcional/react-ui";
import { useEffect, useState } from "react";
import { useUploadFile } from "../hooks/useUpload-file-Cnpj";
import { uploadFileErrors } from "../contracts/upload-file";
import { IGraphQLError } from "@common/contracts";

interface IUploadFileCnpjInput {
  fileName?: string;
  value?: string;
  fileCsv?: File;
}
interface Props {
  closeModal: () => void;
  nameFileUploadModal: (name: string) => void;
}

export default function UploadFileCnpj({
  closeModal,
  nameFileUploadModal,
}: Props) {
  const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
  const [file, setFile] = useState<File>();
  const [array, setArray] = useState([]);
  const { mutateAsync, isLoading } = useUploadFile();
  const [uploadError, setUploadError] = useState<uploadFileErrors>();
  const [successUpload, setSuccessUpload] = useState<boolean>(false);
  const [selectedFile, setSelectFile] = useState<File>();
  const [extensionFile, setextensionFile] = useState<boolean>(true);
  const [sizeFile, setSizeFile] = useState<boolean>();
  useEffect(() => {
    setextensionFile(true);
    let nome = file?.type;
    const fileSize = Number(file?.size) || 0;
    if (fileSize < 5242880) {
      setSizeFile(true);
    } else {
      setSizeFile(false);
    }

    if (nome === "text/csv" || nome === undefined) {
      setextensionFile(true);
    } else {
      setextensionFile(false);
    }
  }, [file, extensionFile, sizeFile]);

  const fileReader = new FileReader();

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  const csvFileToArray = (string) => {
    const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

    const array = csvRows.map((i) => {
      const values = i.split(",");
      const obj = csvHeader.reduce((object, header, index) => {
        object[header] = values[index];
        return object;
      }, {});

      return obj;
    });

    setArray(array);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target?.result;
        csvFileToArray(text);

        let csvFileName: IUploadFileCnpjInput = { fileCsv: file };

        let buff = new Buffer(text as any);
        let base64data = buff.toString("base64");

        let fileUpload: IUploadFileCnpjInput = {
          fileName: csvFileName.fileCsv?.name,
          value: "data:@file/csv;base64," + base64data,
        };

        try {
          const { errors, successfulUpload } = await mutateAsync(
            Object.assign({ input: fileUpload })
          );

          setUploadError(errors[0]);
          setSuccessUpload(successfulUpload);
          setSelectFile(undefined);
          if (successfulUpload) {
            const name = csvFileName.fileCsv?.name || "";
            nameFileUploadModal(name);
          }
        } catch (error: any) {
          console.error(error);
          if (error?.response?.errors) {
            return setGraphQLErrors(error.response.errors || []);
          }
          setGraphQLErrors([
            {
              message:
                "Não foi possível salvar o registro, tente novamente mais tarde.",
            },
          ]);
        }
      };

      fileReader.readAsText(file as any);
    }
  };

  return (
    <>
      <div className="w-full mt-2 flex flex-col">
        {isLoading ? (
          <ApiLoadingSpinner message="Enviando o arquivo..." />
        ) : null}

        {!isLoading &&
        !successUpload &&
        !uploadError &&
        extensionFile &&
        sizeFile ? (
          <input
            type={"file"}
            id={"csvFileInput"}
            accept={".csv"}
            onChange={handleOnChange}
          />
        ) : null}

        {successUpload ? (
          <>
            <h4>Arquivo enviado com sucesso.</h4>
          </>
        ) : null}
        {uploadError ? (
          <>
            <h4>{uploadError.message}</h4>
          </>
        ) : null}
        {!sizeFile ? (
          <>
            <h4>o arquivo é maior que 5MB</h4>
          </>
        ) : null}
        {!extensionFile ? (
          <>
            <h4>Arquivo Rejeitado</h4>
            <h4>
              <strong>FILE TYPE must be text/csv</strong>
            </h4>
            <h4>Selecionar um arquivo válido</h4>
          </>
        ) : null}

        <div className="w-full flex justify-end mt-2">
          <div className="flex-shrink-0 mt-2">
            {successUpload || uploadError || !extensionFile || !sizeFile ? (
              <>
                <Button
                  color="primary"
                  className="max-w-full w-48 text-center"
                  onClick={closeModal}
                >
                  Fechar
                </Button>
              </>
            ) : (
              <>
                <Button
                  color="primary"
                  className="max-w-full w-48 text-center"
                  onClick={(e) => {
                    handleOnSubmit(e);
                  }}
                >
                  ENVIAR
                </Button>

                <br />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
